<h1 mat-dialog-title>{{ 'GeneralMeeting.AreYouSureSelfAttend' | translate }}</h1>

<mat-dialog-content>
    @if (!isLoading) {
        <p [class.mb-2]="shouldAskToSwitchToEmail">{{ actionTitleKey | translate }}</p>
        @if (shouldAskToSwitchToEmail) {
            <button mat-stroked-button class="w-100" (click)="switchToElectronicDelivery()">
                <mat-icon>email</mat-icon>
                <span class="ml-2">{{ 'DeliveryMethod.ChangeToElectronic' | translate }}</span>
            </button>
        }
    } @else {
        <div class="w-100 h-100 d-flex align-items-center justify-content-center">
            <mat-spinner [diameter]="32" />
        </div>
    }
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>{{ 'General.Cancel' | translate }}</button>
    <button [disabled]="isLoading" mat-button (click)="selfRegister()" color="primary">
        {{ 'GeneralMeeting.SelfAttendConfirm' | translate }}
    </button>
</mat-dialog-actions>
